/* eslint-disable import/extensions */
import forms from "./forms.json";
import messages from "./messages.json";
import pages from "./pages.json";
import placeholders from "./placeholders.json";
import tables from "./tables.json";

export default {
  ...forms,
  ...messages,
  ...pages,
  ...placeholders,
  ...tables
};
